import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  courseSectionData: [],
  courseEntireData: [],
  completedLectures: [],
  totalNoOfLectures: 0,
};

const viewCourseSlice = createSlice({
  name: "viewCourse",
  initialState,
  reducers: {
    setCourseSectionData: (state, action) => {
      state.courseSectionData = action.payload;
    },
    setEntireCourseData: (state, action) => {
      state.courseEntireData = action.payload;
    },
    setTotalNoOfLectures: (state, action) => {
      state.totalNoOfLectures = action.payload;
    },
    setCompletedLectures: (state, action) => {
      state.completedLectures = action.payload;
    },
    updateCompletedLectures: (state, action) => {
      state.completedLectures = [...state.completedLectures, action.payload];
    },

    //Clears everything before a different course loads. Without this the slice
    //still holds the previous course while the new one is being fetched, and the
    //lecture page renders the new course's ids against the old course's sections.
    resetViewCourse: (state) => {
      state.courseSectionData = [];
      state.courseEntireData = [];
      state.completedLectures = [];
      state.totalNoOfLectures = 0;
    },
  },
});

export const {
  setCourseSectionData,
  setEntireCourseData,
  setTotalNoOfLectures,
  setCompletedLectures,
  updateCompletedLectures,
  resetViewCourse,
} = viewCourseSlice.actions;

export default viewCourseSlice.reducer;
